import React, { Component } from 'react';

import { getClientPromotions } from '../../data/servicePromotions';
import { sendEmailTest } from '../../data/serviceSendgrid';

import StepOne from './TestSteps/StepOne';
import StepTwo from './TestSteps/StepTwo';
import StepThree from './TestSteps/StepThree';
import StepFour from './TestSteps/StepFour';
import StepFive from './TestSteps/StepFive';

class CrmTest extends Component {
	constructor(props) {
		super(props);
		this.state = {
			promos: [],
			promoList: [],
			widgetList: [],
			eventList: [],
		}
		this.buildPromoList = this.buildPromoList.bind(this);
		this.buildWidgetList = this.buildWidgetList.bind(this);
		this.buildEventList = this.buildEventList.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleReset = this.handleReset.bind(this);
	}

	buildPromoList(e) {
		let clientCode = e.target.value;
		
		getClientPromotions(clientCode)
		.then(response => {
			var promoList = [];
			var promosWithEmails = [];
			// check all the promos to see if they have email widgets
			for (var i = response.length - 1; i >= 0; i--) {
				var widgets = response[i].widgets;

				for (var x = widgets.length - 1; x >= 0; x--) {
					if (widgets[x].type === "email") {
						// compile a list of promos with emails
						var count = promoList.filter(a => a.value === response[i].promoCode).length;
						if (count === 0) {
							promosWithEmails.push(response[i]);
							promoList.push(
								{
									"name" : response[i].name,
									"value" : response[i].promoCode,
								},
							);

						}
					}
				}
			}
			this.setState({
				promoList: promoList,
				promos: promosWithEmails,
				widgetList: [],
				eventList: [],
			});
		});
		

			
	}

	buildWidgetList(e) {
		let promoCode = e.target.value;
		let promo = this.state.promos.filter( promo => { return promo.promoCode === promoCode; })[0];
		// promo = promo[0];
		let widgets = promo.widgets;
		let widgetList = [];

		for (var i = widgets.length - 1; i >= 0; i--) {
			if (widgets[i].type === "email") {
				// compile a list of email widgets
				widgetList.push(
					{
						"name" : widgets[i].name,
						"value" : widgets[i].widgetId,
					},
				);
			}
		}
		this.setState({
			widgetList: widgetList,
			eventList: [],
		});

	}

	buildEventList(e) {
		let widgetId = parseInt(e.target.value, 10);

		var promoCode = document.getElementById('promoCode')
		promoCode = promoCode.options[promoCode.selectedIndex].value;
		let promo = this.state.promos.filter( promo => { return promo.promoCode === promoCode; })[0];

		let events = promo.widgets.filter( widget => { return widget.widgetId === widgetId; })[0].events;

		console.log(events);

		let eventList = [];

		for (var i = events.length - 1; i >= 0; i--) {
			
				eventList.push(
					{
						"name" : events[i].eventId,
						"value" : events[i].eventId,
					},
				);
		}
		this.setState({
			eventList: eventList.reverse(),
		});
	}

	// move this to serviceCrm
	handleSubmit() {
		var promoCode = document.getElementById('promoCode')
		promoCode = promoCode.options[promoCode.selectedIndex].value;
		console.log(promoCode);

		var clientCode = document.getElementById('clientCode')
		if (promoCode !== "Select...") {
			clientCode = clientCode.options[clientCode.selectedIndex].value;
		} else {
			clientCode = null
		}
		var widgetId = document.getElementById('widgetId')
		if (promoCode !== "Select...") {
			widgetId = widgetId.options[widgetId.selectedIndex].value;
		} else {
			widgetId = null
		}
		var eventId = document.getElementById('eventId')
		if (promoCode !== "Select...") {
			eventId = eventId.options[eventId.selectedIndex].value;
		} else {
			eventId = null
		}
		
		var firstName = document.getElementById('firstName').value;
		var lastName = document.getElementById('lastName').value;
		var email = document.getElementById('email').value;
		var phone = document.getElementById('phone').value;
		var location = document.getElementById('location').value;
		var postalCode = document.getElementById('postalCode').value;
		var locCode = "";
		if (clientCode === "fyw") {
			locCode = "24619";
		}

		var paramsBody = {
			"clientCode": clientCode,
			"promoCode": promoCode,
			"widgetId": widgetId,
			"testEventId": eventId,
			"firstName": firstName,
			"lastName": lastName,
			"email": email,
			"phone": phone,
			"location": location,
			"postalCode": postalCode,
			"skipCrm": true,
			"locationCode": locCode,
		};

		if (
			clientCode !== "Select..." &&
			promoCode !== "Select..." &&
			email !== ""
		) {
			
			sendEmailTest(paramsBody).then(response => {
				console.log(response);
				if (response.success === true) {
					document.getElementById("send-message").innerHTML = response.message;
					setTimeout(this.handleReset, 3000);
				} else {
					document.getElementById("send-message").innerHTML = response.message;
				}
			})

		} else {
			document.getElementById("send-message").innerHTML = "Promotion, Client, & Email are required fields, please confirm they are filled in.";
		}
	}

	handleReset() {
		document.getElementById("clientCode").selectedIndex = "0";
		document.getElementById("promoCode").selectedIndex = "0";
		document.getElementById("widgetId").selectedIndex = "0";
		document.getElementById("eventId").selectedIndex = "0";
		document.getElementById('firstName').value = "";
		document.getElementById('lastName').value = "";
		document.getElementById('email').value = "";
		document.getElementById('phone').value = "";
		document.getElementById('location').value = "";
		document.getElementById('postalCode').value = "";
		document.getElementById("send-message").innerHTML = "";
	}

	render() {
		const { promoList, widgetList, eventList } = this.state;
		const clients = this.props.clients;

		return (
			<div>
				<section className="section campaign-test">
					<h3>Email Campaign Test Form</h3>
					<form className="form input-group" id="email-campaign-test">
						<StepOne data={clients} doFunction={this.buildPromoList} />
						<StepTwo data={promoList} doFunction={this.buildWidgetList} />
						<StepThree data={widgetList} doFunction = {this.buildEventList} />
						
						{(eventList && eventList.length > 0) && (
							<React.Fragment>
								<StepFour data={eventList} />
								<StepFive doFunction={this.handleSubmit} />
							</React.Fragment>
						)}
					</form>
				</section>
			</div>
		)
	}
}
export default CrmTest;


// WEBPACK FOOTER //
// ./src/component_crmTest/components/CrmTest.js